/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch } from "react-redux";
import Header from "../../../components/common/layout/Header";
import GrievanceHeader from "../../../components/common/layout/GrievanceHeader";
import VigilanceHeader from "../../../components/common/layout/VigilanceHeader";
import ChatbotHeader from "../../../components/common/layout/ChatbotHeader";
import Details from "../../../components/passenger/profile/Details";
import { useEffect } from "react";
import { dataActions } from "../../../shared/store/data-Slice";
import Canonical from "../../../components/common/layout/Canonical";

const Profile = ({ popup, type }: any) => {
    const dispatch = useDispatch();

    useEffect(() => {
        popup === "complaint" ? dispatch(dataActions.setComplaintDetail(true)) : dispatch(dataActions.setComplaintDetail(false))
        popup === "add-remarks" ? dispatch(dataActions.setAddRemarksComplaint(true)) : dispatch(dataActions.setAddRemarksComplaint(false))
    }, [popup])

    return (
        <div className='bg-white dark:bg-bgDarkDull'>
            <Canonical />
            {type === "grievance" ? <GrievanceHeader /> : type === "vigilance" ? <VigilanceHeader /> : type === "chatbot" ? <ChatbotHeader /> : <Header type={type} />}
            <div id="home">
                <Details type={type} />
            </div>
        </div>
    );
};

export default Profile;